export default __webpack_public_path__ + "static/media/circle1_filled-min.052e01fe.png";